function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import cn from 'classnames';
import React, { FC, HTMLAttributes } from 'react';
import { Icon } from '../../Icon';
import { Link } from '../../Link';
import { formatPrice } from '../helpers/formatPrice';
require("./ProductAnalog.css");
var styles = {
  "Root": "ProductAnalog-module-Root_37-",
  "Icon": "ProductAnalog-module-Icon_3Lt"
};
export const ProductAnalog = ({
  price,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Link, _extends({
    className: cn(styles.Root)
  }, rest), "\u0410\u043D\u0430\u043B\u043E\u0433 \u043E\u0442 ", formatPrice(price), " ", /*#__PURE__*/React.createElement(Icon, {
    name: "chevronRight",
    className: styles.Icon
  }));
};